import { Platform } from 'react-native';

export const ios = Platform.OS === 'ios';
export const android = Platform.OS === 'android';
export const app = android || ios;
export const web = Platform.OS === 'web';
export const macOS =
  // @ts-ignore navigator obj not present on mobile
  !app && navigator?.platform?.toUpperCase()?.indexOf('MAC') >= 0;
